export interface ColorSpectrum {
  main: string;
  light20: string;
  dark40: string;
}
export const ColorPalette: ColorSpectrum[] = [
  { main: "#aacbb5", light20: "#e9f2ec", dark40: "#40694e" },
  { main: "#dec59d", light20: "#f8f2e9", dark40: "#83622c" },
  { main: "#7bacec", light20: "#d4e4f9", dark40: "#144687" },
  { main: "#e3a7dd", light20: "#fcf4fb", dark40: "#902e86" },
  { main: "#4a9c8e", light20: "#cbe7e2", dark40: "#29574f" },
  { main: "#ff70a6", light20: "#ffd6e5", dark40: "#a3003e" },
  { main: "#fbbc85", light20: "#fef2e8", dark40: "#ae5406" },
  { main: "#83f8ff", light20: "#e9feff", dark40: "#00acb6" },
  { main: "#f70945", light20: "#fdcfda", dark40: "#32020e" },
  { main: "#887dd3", light20: "#cec9ed", dark40: "#2a2163" },
  { main: "#f7b267", light20: "#fff3e0", dark40: "#a65c00" },
  { main: "#70d6ff", light20: "#e0f7ff", dark40: "#007a99" },
  { main: "#ff9770", light20: "#ffe8e0", dark40: "#a63c00" },
  { main: "#b5ead7", light20: "#e6fff6", dark40: "#2e7d5b" },
  { main: "#cdb4db", light20: "#f6f0fa", dark40: "#6d4c7d" },
  { main: "#ffd6a5", light20: "#fff8e6", dark40: "#a67c00" },
  { main: "#9bf6ff", light20: "#e0fcff", dark40: "#007c8a" },
  { main: "#fdffb6", light20: "#ffffe0", dark40: "#a6a600" },
  { main: "#caff70", light20: "#f4ffe0", dark40: "#5a9900" },
  { main: "#bdb2ff", light20: "#ecebff", dark40: "#4c3ca6" },
];

// Dark theme palette: light20 for icon fills (darker), dark40 for text/borders (lighter), main is vivid
export const ColorPaletteDark: ColorSpectrum[] = [
  { main: "#b7e3c7", light20: "#22332b", dark40: "#e0f5ea" },
  { main: "#f0d9b3", light20: "#332b1c", dark40: "#f9f3e4" },
  { main: "#8fc7ff", light20: "#1a2633", dark40: "#e3f1ff" },
  { main: "#f0b3e9", light20: "#321c2e", dark40: "#fbeaf8" },
  { main: "#5fd1be", light20: "#1c2b29", dark40: "#e0f7f3" },
  { main: "#ff8ab8", light20: "#331c28", dark40: "#ffe6f2" },
  { main: "#ffd19e", light20: "#33281c", dark40: "#fff7ec" },
  { main: "#a5faff", light20: "#1c2b2c", dark40: "#e6feff" },
  { main: "#ff3a6d", light20: "#331c22", dark40: "#ffe6ee" },
  { main: "#a89cff", light20: "#241c33", dark40: "#f0edff" },
  { main: "#ffd18c", light20: "#332a1c", dark40: "#fff7e6" },
  { main: "#8eeaff", light20: "#1c2933", dark40: "#e6faff" },
  { main: "#ffb38c", light20: "#33241c", dark40: "#fff0e6" },
  { main: "#c7ffe6", light20: "#1c332a", dark40: "#e6fff7" },
  { main: "#e6cfff", light20: "#2a1c33", dark40: "#f7e6ff" },
  { main: "#ffe6b3", light20: "#332f1c", dark40: "#fffbe6" },
  { main: "#b3f6ff", light20: "#1c2f33", dark40: "#e6fcff" },
  { main: "#fdffb6", light20: "#33331c", dark40: "#ffffe6" },
  { main: "#e6ffb3", light20: "#29331c", dark40: "#f7ffe6" },
  { main: "#d6cfff", light20: "#241c33", dark40: "#f0f0ff" },
];

export const ColorSpectrums = {
  disabled: { main: "#222", light20: "#aaa", dark40: "#777" },
  highContrast: { main: "black", light20: "#fff", dark40: "#fff" },
};
